<template>
  <div>
    <header-component></header-component>
    <div class="px-2 py-2 w-full">
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0" style="text-transform:capitalize;">Credit Notes</h3>
        </div>
        <el-table
          :data="creditNotes"
          class="table-responsive table-flush sales-table"
          header-row-class-name="thead-light"
          v-loading="loading"
        >
          <el-table-column label="Date" min-width="90px">
            <template slot-scope="scope">{{ scope.row.created_at | formatDate }}</template>
          </el-table-column>
          <el-table-column label="Customer" min-width="120px">
            <template slot-scope="scope">
              <span v-if="scope.row.customer">
                {{ scope.row.customer.first_name }} {{ scope.row.customer.last_name }}
              </span>
              <span v-else>—</span>
            </template>
          </el-table-column>
          <el-table-column label="Return Amount" min-width="100px">
            <template slot-scope="scope">
              <span class="text-red font-weight-bold">{{ scope.row.amount | currency }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Settlement" min-width="90px">
            <template slot-scope="scope">
              <span
                class="badge"
                :class="scope.row.settlement_type === 'wallet' ? 'badge-success' : 'badge-info'"
              >
                {{ scope.row.settlement_type === 'wallet' ? 'Wallet Credit' : 'Cash Refund' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="Branch" min-width="110px">
            <template slot-scope="scope">
              <span v-if="scope.row.branch">{{ scope.row.branch.name }}</span>
              <span v-else class="text-muted">—</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="card-footer d-flex justify-content-end" v-if="pagination.last_page > 1">
          <el-pagination
            :current-page="pagination.current_page"
            :page-size="pagination.per_page"
            :total="pagination.total"
            layout="prev, pager, next"
            @current-change="fetchPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Table, TableColumn, Pagination
} from "element-ui";
import { mapGetters } from "vuex";
import { format } from "date-fns";
import { apiHelper } from "@/utils/helpers";
import endpoints from "@/utils/constants";
import headerComponent from "../Components/HeaderComponent";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination,
    "header-component": headerComponent
  },
  filters: {
    formatDate(date) {
      return date ? format(new Date(date), "DD MMM YYYY") : "—";
    },
    currency(value) {
      const amount = parseFloat(value) || 0;
      return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(amount);
    }
  },
  data() {
    return {
      creditNotes: [],
      pagination: {},
      loading: false
    };
  },
  mounted() {
    this.fetchPage(1);
  },
  methods: {
    fetchPage(page) {
      this.loading = true;
      apiHelper
        .call("get", endpoints.LARAVEL_BASE_URL + "/api/v1/credit-notes/metadata?page=" + page)
        .then(res => {
          this.creditNotes = res.data.data;
          this.pagination = {
            current_page: res.data.current_page,
            per_page: res.data.per_page,
            total: res.data.total,
            last_page: res.data.last_page
          };
        })
        .catch(() => {
          this.$notify({ message: "Failed to load credit notes.", type: "danger", title: "Error" });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
.sales-table .el-table__row {
  text-transform: capitalize;
}
.text-red {
  color: #dc3545;
}
</style>
